import styled from 'styled-components'
import { Link } from 'gatsby'

import {
    Sizes,
    FontLight,
    FontRegular,
    Colors,
    Breakpoints
} from './../../utils/variables'

export const FooterWrapper = styled.div`
    width: 100%;
    overflow: hidden;

    border-top: 1px solid rgba(0, 0, 0, 0.2);

    @media screen and (min-width: ${Breakpoints.wide}) {
        padding: 100px 0 0;
    }
`

export const List = styled.ul`
    display: grid;
    grid-template-columns: repeat(1, 1fr);

    width: 100%;
    max-width: ${Sizes.maxContainerWidth};

    margin: 30px auto 60px auto;
    padding: 0 30px;

    @media screen and (min-width: ${Breakpoints.wide}) {
        grid-template-columns: repeat(4, 1fr);

        margin: 0 auto 100px auto;
    }
`

export const Item = styled.li`
    margin-bottom: 20px;

    &:first-of-type {
        margin-bottom: 35px;
    }

    &:last-of-type {
        margin-bottom: 0;
    }

    @media screen and (min-width: ${Breakpoints.wide}) {
        margin-bottom: 40px;

        &:first-of-type {
            margin-bottom: 0;

            a {
                display: inline-block;

                margin-top: 45px;
            }
        }

        &:last-of-type {
            display: none;
        }
    }
`

export const Heading = styled.h4`
    margin-bottom: 20px;

    ${FontRegular}
    font-size: 13px;
    line-height: 20px;

    color: ${Colors.black};

    text-transform: uppercase;

    @media screen and (min-width: ${Breakpoints.wide}) {
        margin-bottom: 35px;

        font-size: 13px;
    }
`

export const Text = styled.p`
    ${FontLight}
    font-size: 13px;
    line-height: 20px;
    letter-spacing: 0.5px;

    color: ${Colors.black};

    @media screen and (min-width: ${Breakpoints.wide}) {
        font-size: 13px;
        line-height: 23px;
    }
`

export const MenuLink = styled(Link)`
    display: block;
    
    ${FontLight}
    font-size: 13px;
    line-height: 20px;
    letter-spacing: 0.5px;

    color: ${Colors.black};

    text-decoration: none;
`

export const Mail = styled.a`
    display: block;

    ${FontLight}
    font-size: 13px;
    line-height: 20px;
    letter-spacing: 0.5px;

    color: ${Colors.black};

    text-decoration: none;

    transition: opacity 0.15s ease-out;

    &:hover {
        opacity: 0.3;
    }

    @media screen and (min-width: ${Breakpoints.wide}) {
        font-size: 13px;
        line-height: 23px;
    }
`

export const Bottom = styled.div`
    display: block;
    position: relative;
    
    width: 100%;
    height: 115px;

    @media screen and (min-width: ${Breakpoints.wide}) {
        height: 250px;
    }
`

export const Copyright = styled.div`
    position: absolute;
    
    top: 50%;
    left: 50px;

    display: block;

    color: ${Colors.blue};

    @media screen and (min-width: ${Breakpoints.wide}) {
        left: auto;
        right: 50px;
    }
`

export const CopyrightLink = styled(Link)`
    ${FontLight}
    font-size: 13px;
    letter-spacing: 0.5px;

    color: currentColor;

    text-decoration: none;
`

export const StyledLink = styled.a`
    ${FontLight}
    font-size: 13px;
    letter-spacing: 0.5px;

    color: currentColor;

    text-decoration: none;
`

export const Line = styled.div`
    display: inline-block;
    vertical-align: middle;

    width: 5px;
    height: 1px;

    margin: 0 5px;
    background-color: ${Colors.blue};
`

export const Credit = styled.div`
    display: inline-block;
    vertical-align: middle;

    ${FontLight}
    font-size: 13px;
    letter-spacing: 0.5px;

    color: ${Colors.blue};
`